import Carousel from 'nuka-carousel';
import { isMobile } from 'react-device-detect';
import { useState } from "react";
import { useSelector } from 'react-redux';

import checkedNow from '../Pregnancy/assets/checkedNew.svg';
import checkedWhite from '../Pregnancy/assets/checkedNew-white.svg';
import iconXwhite from '../Pregnancy/assets/whiteXICcon.svg';
import whiteHeart from '../../assets/heart.png';
import crown from '../../assets/crown.svg';

import { className, IsWindow, scrollToSection } from "../../Utils.js";
import CarouselMobileDots from './CarouselMobileDots/CarouselMobileDots.js';
import { useTranslations } from "../../lang/TranslationHooks";

import "./AppsCarousel.css";

const AppsCarousel = ({ sectionKey }) => {
    const { language } = useSelector((state) => state.home);
    const [slideIndex, setSlideIndex] = useState(isMobile ? 0 : 1);
    const { staticTranslate } = useTranslations();

    const hasVisibleContent = (str) => {
        if (!str) return false;
        const cleaned = str.replace(/<br\s*\/?>/gi, '').trim();
        return cleaned.length > 0;
    };

    const renderFuncItem = (text, title, alt, index) =>
        hasVisibleContent(text) && (
            <div className={className('carousel-func')}>
                <img
                    className={className(title && 'x-icon')}
                    src={
                        title
                            ? (index === 0 ? checkedWhite : iconXwhite)
                            : checkedNow
                    }
                    alt={alt}
                />
                <p dangerouslySetInnerHTML={{ __html: text }} />
            </div>
        );

    const newData = [
        {
            id: 1,
            title: staticTranslate('t_pregnancy_price_component_title', true),
            freePlan: staticTranslate("t_free_plan", true),
            freeFunc: staticTranslate('t_pregnancy_accordion_functioanality_title', true),
            feiaPremium: language !== 'es' && staticTranslate('t_pregnancy_premium_title', true),
            feiaArchive: staticTranslate('t_pregnancy_slider_archive', true),
            feiaParents: staticTranslate('t_pregnancy_slider_parents', true),
            feiaInformation: staticTranslate('t_pregnancy_accordion_information_title', true),
            isPremium: false,
            feiaPpus: language !== 'bg' && staticTranslate('t_pregnancy_accordion_important_title', true),
            miniAps: language !== 'bg' && staticTranslate('t_pregnancy_accordion_miniaps_title', true),
            ios: 'https://apps.apple.com/us/app/feia-%D0%B1%D1%80%D0%B5%D0%BC%D0%B5%D0%BD%D0%BD%D0%BE%D1%81%D1%82/id1299624022?ls=1',
            android: "https://play.google.com/store/apps/details?id=bg.feia.Pregnancy"
        },
        {
            id: 2,
            subTitle: staticTranslate("t_feia_premium", true),
            duration: staticTranslate("t_pregnancy_price_component_monthly_duration", true),
            price: staticTranslate("t_pregnancy_price_component_monthly_price", true),
            freeFunc: staticTranslate('t_pregnancy_accordion_functioanality_title', true),
            feiaPremium: language !== 'es' && staticTranslate('t_pregnancy_premium_title', true),
            feiaParents: staticTranslate('t_pregnancy_slider_parents', true),
            feiaPpus: language !== 'bg' && staticTranslate('t_pregnancy_accordion_important_title', true),
            feiaArchive: staticTranslate('t_pregnancy_slider_archive', true),
            feiaInformation: staticTranslate('t_pregnancy_accordion_information_title', true),
            miniAps: language !== 'bg' && staticTranslate('t_pregnancy_accordion_miniaps_title', true),
            isPremium: true,
            planRenewal: staticTranslate('t_pregnancy_price_component_plan_renewal', true),
            ios: 'https://apps.apple.com/us/app/feia-%D0%B1%D1%80%D0%B5%D0%BC%D0%B5%D0%BD%D0%BD%D0%BE%D1%81%D1%82/id1299624022?ls=1',
            android: "https://play.google.com/store/apps/details?id=bg.feia.Pregnancy"
        },
        {
            id: 3,
            subTitle: staticTranslate("t_feia_premium", true),
            duration: staticTranslate('t_pregnancy_price_component_yearly_duration', true),
            price: staticTranslate("t_pregnancy_price_component_yearly_price", true),
            secondPrice: staticTranslate('t_pregnancy_price_component_yearly_second_price', true),
            freeFunc: staticTranslate('t_pregnancy_accordion_functioanality_title', true),
            feiaPremium: language !== 'es' && staticTranslate('t_pregnancy_premium_title', true),
            feiaPpus: language !== 'bg' && staticTranslate('t_pregnancy_accordion_important_title', true),
            feiaParents: staticTranslate('t_pregnancy_slider_parents', true),
            feiaArchive: staticTranslate('t_pregnancy_slider_archive', true),
            feiaInformation: staticTranslate('t_pregnancy_accordion_information_title', true),
            isPremium: true,
            montlyPrice: staticTranslate('t_pregnancy_montlyprice', true),
            planRenewal: staticTranslate('t_pregnancy_price_component_plan_renewal', true),
            bestSeller: staticTranslate('t_pregnancy_price_component_best_seller', true),
            savePercent: staticTranslate('t_pregnancy_price_component_save_percent', true),
            miniAps: language !== 'bg' && staticTranslate('t_pregnancy_accordion_miniaps_title', true),
            ios: 'https://apps.apple.com/us/app/feia-%D0%B1%D1%80%D0%B5%D0%BC%D0%B5%D0%BD%D0%BD%D0%BE%D1%81%D1%82/id1299624022?ls=1',
            android: "https://play.google.com/store/apps/details?id=bg.feia.Pregnancy"
        }
    ];

    const renderCardContent = (item) => (
        [
            { text: item?.freeFunc, alt: 'freeFunc' },
            { text: item?.feiaPremium, alt: 'feiaPremium' },
            { text: item?.feiaParents, alt: 'feiaParents' },
            { text: item?.feiaArchive, alt: 'feiaArchive' },
            { text: item?.feiaInformation, alt: 'feiaInformation' },
            { text: item?.feiaPpus, alt: 'feiaPpus' },
            { text: item?.miniAps, alt: 'miniAps' },
        ].map((entry, i) => renderFuncItem(entry.text, item?.title, entry.alt, i))
    );

    const renderCard = (item, index) => (
        <div
            style={{ pointerEvents: 'auto', zIndex: 10 }}
            key={`card-${index}`}
            className={className('carousel-card')}
            onClick={() => {
                isMobile
                    ? window.location.href = window.navigator.userAgent.includes('Mac OS') ? item?.ios : item?.android
                    : scrollToSection('add-price-container');
            }}
        >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                {item?.bestSeller && (
                    <div className={className('info-mark')}>
                        <p className={className('best-seller')}>&#9733;{item?.bestSeller}</p>
                        <p className={className('save-price')}>{item?.savePercent}</p>
                    </div>
                )}
                {item?.title && <h3 className={className('card-heading')}>{item?.title}</h3>}
                {item?.freePlan && <p className={className("card-freePlan")}>{item?.freePlan}</p>}
                {!item?.isPremium && (
                    <div className={className('heart-container')}>
                        <img src={whiteHeart} alt='white heart' />
                    </div>
                )}
                {item?.duration && (
                    <div className={className('container-info')}>
                        <img src={crown} alt="crown" loading="lazy" className={className('carousel-img-crown')} />
                        {item?.subTitle && <p className={className('card-subtitle')}>{item?.subTitle}</p>}
                        <p className={className('card-duration')}>{item?.duration}</p>
                        <p className={className('card-price')}>{language === 'bg' ? 'BGN' : 'EUR'}{item.price}</p>
                        {item?.montlyPrice && <p className={className('montlyPrice')}>{item.montlyPrice}</p>}
                    </div>
                )}
            </div>
            <div className={className('carousel-content')}>
                {renderCardContent(item)}
            </div>
            <div className={className(item?.title ? "carousel-button-white" : 'carousel-button')}>
                {staticTranslate('t_pregnancy_second_section_install_now', true)}
            </div>
            {item?.planRenewal && (
                <p className={className('plan-renewal')}>*{item?.planRenewal}</p>
            )}
        </div>
    );

    return (
        <div id={sectionKey}>
            {isMobile ? (
                <div className={className('carousel')}>
                    <Carousel
                        wrapAround
                        slidesToShow={3}
                        dragging
                        swiping
                        transitionMode="scroll3d"
                        cellSpacing={120}
                        withoutControls
                        cellAlign="center"
                        animation="zoom"
                        opacityScale={1}
                        frameOverflow="false"
                        slideIndex={slideIndex}
                        slideOffset={IsWindow.innerWidth / 4}
                        style={{ width: '100vw' }}
                        afterSlide={setSlideIndex}
                    >
                        {newData.map(renderCard)}
                    </Carousel>
                </div>
            ) : (
                <div className={className('carousel')}>
                    {newData.map(renderCard)}
                </div>
            )}
            {isMobile && <CarouselMobileDots data={newData} slideIndex={slideIndex} />}
        </div>
    );
};

export default AppsCarousel;
